export const PAYMENT_METHODS_URL = '/api/v1/user/payment'
export const PAYMENT_METHODS_GET_URL = '/api/v1/user/payment/get'
export const PAYMENT_INTENT_TOKEN = '/api/v1/user/payment/intent'
